import React from "react";
import styles from "../utils/gridStyles.js";
import dateFormat from 'dateformat';
import setHeaderRender from "../../components/app/setHeaderRender";
import { Form, Button, Modal, Col, Row, Tab, Tabs, Alert, Accordion } from 'react-bootstrap';

const setColumns = ({ modalDetail, allowWrite, changeDelay, setLoading, updateSelectMultiRows, selectUnselectAllRows }) => {

    return [
        {
            id: "checkbox",
            visible: true,
            pinned: true,
            width: "54px",
            cellRenderer: ({ value, data, onChange, disabled}) => ( <input type="checkbox" onChange={ onChange } checked={ value } disabled={ disabled }
            onClick={ () => { updateSelectMultiRows(data.fieldIdOrder); } } /> ),
            headerCellRenderer: ({ checked, disabled, onChange }) => ( <input type="checkbox" onChange={ onChange } checked={ checked } disabled={ disabled } 
            onClick={selectUnselectAllRows} /> )
        },
        {
            id: "code",
            field: "code",
            label: "code",
            width: '100px',
            sortable: false,
            resizable: true,
            headerCellRenderer: ({tableManager, column }) => ( setHeaderRender({'nameHeader':'code', changeDelay, tableManager, column}) )
        },
        {
            id: "1",
            field: "storeCode",
            label: "StoreCode",
            width: '130px',
            sortable: false,
            headerCellRenderer: ({tableManager, column }) => ( setHeaderRender({'nameHeader':'StoreCode', changeDelay, tableManager, column}) )
        },
        {
            id: "2",
            field: "clientName",
            label: "ClientName",
            width: '200px',
            sortable: false
        },
        {
            id: "3",
            field: "status",
            label: "Status",
            sortable: false,
            headerCellRenderer: ({ tableManager, column }) => (<>
                <table><tbody>
                    <tr><td>Status</td></tr>
                    <tr>
                        <td>
                            <Form.Select
                                size="sm"
                                style={{ paddingTop: 0, paddingBottom: 0 }}
                                onChange={(e) => {
                                    changeDelay(e.target.value, tableManager, column);
                                    setLoading(true);
                                }}
                            >
                                <option value="">All</option>
                                <option value='[1,2,3,4,5,6]'>Paid</option>
                                <option value='0'>Pending</option>
                                <option value='-1'>Cancelled</option>
                            </Form.Select>
                        </td>
                    </tr>
                </tbody></table> </>),
            cellRenderer: ({
                tableManager,
                value,
                data,
                column,
                colIndex,
                rowIndex
            }) => (data.status)
        },
        {
            id: "12",
            field: "statusT1Pagos",
            label: "statusT1Pagos",
            sortable: false,
            headerCellRenderer: ({ tableManager, column }) => (<>
                <table><tbody>
                    <tr><td>Status T1Pagos</td></tr>
                    <tr>
                        <td>
                            <Form.Select
                                size="sm"
                                style={{ paddingTop: 0, paddingBottom: 0 }}
                                onChange={(e) => {
                                    changeDelay(e.target.value, tableManager, column);
                                    setLoading(true);
                                }}
                            >
                                <option value="">All</option>
                                <option value='2'>Paid</option>
                                <option value='1'>Pendign</option>
                                <option value='0'>Sending Failed</option>
                                <option value='-1'>External</option>
                            </Form.Select>
                        </td>
                    </tr>
                </tbody></table> </>),
            cellRenderer: ({
                tableManager,
                value,
                data,
                column,
                colIndex,
                rowIndex
            }) => (data.statusT1Pagos)
        },
        {
            id: "4",
            field: "customer.username",
            label: 'Customer Username',
            sortable: false,
            headerCellRenderer: ({tableManager, column }) => ( setHeaderRender({'nameHeader':'CustomerUsername', changeDelay, tableManager, column}) ),
            cellRenderer: ({
                tableManager,
                value,
                data,
                column,
                colIndex,
                rowIndex
            }) => (data.customer.username)
        },
        {
            id: "6",
            field: "customer.name",
            label: 'Customer Name',
            sortable: false,
            headerCellRenderer: ({tableManager, column }) => ( setHeaderRender({'nameHeader':'CustomerName', changeDelay, tableManager, column}) ),
            cellRenderer: ({
                tableManager,
                value,
                data,
                column,
                colIndex,
                rowIndex
            }) => (data.customer.name)
        },
        {
            id: "7",
            field: "total",
            label: "Total",
            width: '100px',
            sortable: false,
            headerCellRenderer: ({tableManager, column }) => ( setHeaderRender({'nameHeader':'Total', changeDelay, tableManager, column}) ),
            cellRenderer: ({
                tableManager,
                value,
                data,
                column,
                colIndex,
                rowIndex
            }) => ( '$ ' + data.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))
        },
        {
            id: "8",
            field: "payMethod",
            label: "PayMethod",
            width: '130px',
            sortable: false,
            headerCellRenderer: ({tableManager, column }) => ( setHeaderRender({'nameHeader':'PayMethod', changeDelay, tableManager, column}) ),
        },
        {
            id: "9",
            field: "identityShopId",
            label: "Identity ShopId",
            width: '150px',
            sortable: false,
            headerCellRenderer: ({tableManager, column }) => ( setHeaderRender({'nameHeader':'Identity ShopId', changeDelay, tableManager, column}) ),
        },
        {
            id: "10",
            field: "paymentTransactionId",
            label: "Transaction ID",
            sortable: false,
            headerCellRenderer: ({tableManager, column }) => ( setHeaderRender({'nameHeader':'Transaction ID', changeDelay, tableManager, column}) ),
        },
        {
            id: "11",
            field: "createdAt",
            label: "CreatedAt",
            sortable: false,
            cellRenderer: ({
                tableManager,
                value,
                data,
                column,
                colIndex,
                rowIndex
            }) => (dateFormat(data.createdAt, "dd/mm/yyyy", true)),
        },
        {
            id: "buttons",
            label: "Action",
            width: '110px',
            pinned: true,
            sortable: false,
            resizable: false,
            cellRenderer: ({
                tableManager,
                value,
                data,
                column,
                colIndex,
                rowIndex
            }) => (
                <div style={styles.styleButton.buttonsCellContainer}>
                    
                    {false
                        ? (<> <button
                            title="Edit"
                            style={styles.styleButton.editButton}
                            onClick={(e) => {
                                e.stopPropagation();
                                modalDetail(data.code, "Edit");
                            }}
                        >
                            {styles.EDIT_SVG}
                        </button> {" - "} </>)
                        : ''
                    }
                    <button
                        title="View"
                        style={styles.styleButton.viewButton}
                        onClick={(e) => {
                            e.stopPropagation();
                            modalDetail(data.code, data.storeCode, "View");
                        }}
                    >
                        {styles.VIEW_SVG}
                    </button>
                </div>
            )
        }
    ];
};

export default setColumns;
